 <template>
  <div>

    <v-card style="background-color: #eee" v-if="isNew">
      <v-card-text class="text-h5 font-weight-bold">
        <core-file-upload
          ref="fileUpload"
          @input="storeImage"
          :label="labelDef"
        />
      </v-card-text>
    </v-card>

    <v-card style="background-color: #eee" v-if="!isNew">
      <v-card-text class=" font-weight-bold">
        <a :href="imgPath"
          >{{ item.name }} ({{ Math.ceil(item.size / 1024) }} Kb)</a
        >
         <v-img v-if="item.type.includes('image')"
            :max-height="item.height"
            :max-width="item.width"
            :src="imgPath"
          ></v-img>
      </v-card-text>
      <v-card-actions>
        <v-btn small color="lighten-2 warning" @click="deleteFile">
          <v-icon small>mdi-delete</v-icon>
          Remove File
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
 
<script>
let { post, getDetail } = require("@/api/base_entity");
import { mapActions } from "vuex";

export default {
  props: {
    value: { type: Number },
    index: { type: String, default: "" },
    label: {type: String, default: null},
    entityId: { type: Number },
    entity: { type: String },
  },
  data() {
    return {
      base64: null,
      item: {},
      image: {
        entity: this.entity,
        entity_id: this.entityId,
      },
      imgHeight: 320,
      imgWidth: 480,
      loadingStore: false,
      editMode: false,
    };
  },
  watch: {},
  mounted() {
    this.getConfig();
    if (this.value) {
      getDetail("file", { id: this.value }).then((ret) => {
        this.item = ret;
      });
    }
  },
  computed: {
    isNew() {
      return !this.item.id;
    },
    imgPath() {
      return (
        this.$store.getters.s3BaseUrl + this.item.uuid + this.item.extension
      );
    },
    labelDef() {
      return this.label || "Trascina qua il file che vuoi caricare"
    }
  },
  methods: {
    ...mapActions("app", ["getConfig"]),
    onFileInfo(info) {
      this.image = info;
      this.image.entity = this.entity;
      this.image.entity_id = this.entityId;
    },
    onInput(base64) {
      this.image.base64 = base64;
    },
    storeImage(val) {
      if (val.base64) {
        this.image = {
          lastModified: val.lastModified,
          name: val.name,
          size: val.size,
          type: val.type,
          base64: val.base64,
          entity: this.entity,
          entity_id: this.entityId,
        };
      }

      this.loadingStore = true;

      return post("file", this.image)
        .then((ret) => {
          this.item = ret.data;

          this.$emit("input", this.item.id);

          this.$root.$emit("openSnackbar", {
            message: "File caricato con successo!",
            color: "success",
          });
          this.$refs.fileUpload.setBusy(false);
        })
        .catch((msg) => {
          this.$root.$emit("openSnackbar", {
            message:
              "Si è verificato un errore durante il caricamento del file : " +
                msg.response.data.message || "Error",
            color: "error",
          });
        })
        .finally(() => {
          this.loadingStore = false;
        });
    },
    deleteFile() {
      this.item = {}
      this.$emit("input", null);
      this.image = null
      this.base64 = null
    },
  },
};
</script>
 
 <style>
.imageComponent {
  background-color: rgb(102, 102, 102);
}
</style>